/* FA4 name -> @fortawesome SVG icon. One row per name in the app's inventory
   (see fa4NameMap.test.tsx). -o variants use the REGULAR style (outline),
   everything else SOLID (exceptions commented inline). FA7 kept FA6's names;
   renames vs FA4 are commented. */
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faUpDownLeftRight, // FA4 arrows-alt
  faScaleBalanced, // FA4 balance-scale
  faBars,
  faBell,
  faBellSlash,
  faBoxArchive /* FA4 archive */,
  faBriefcase,
  faCalendarDays, // FA4 calendar (grid calendar)
  faChartLine, // FA4 line-chart
  faCheck,
  faCircleCheck, // FA4 check-circle
  faChevronDown,
  faChevronRight,
  faGear /* FA4 cog */,
  faGears /* FA4 cogs */,
  faComment,
  faCreditCard,
  faUtensils, // FA4 cutlery
  faDownload,
  faPenToSquare, // FA4 edit
  faEllipsisVertical, // FA4 ellipsis-v
  faEnvelope,
  faExclamation,
  faTriangleExclamation, // FA4 warning / exclamation-triangle
  faEye,
  faFile,
  faFlag,
  faGavel,
  faGlobe,
  faHouse, // FA4 home
  faCircleInfo, // FA4 info-circle
  faLock,
  faMap,
  faLocationDot, // FA4 map-marker
  faMinus,
  faSquareMinus, // FA4 minus-square
  faPlus,
  faSquarePlus, // FA4 plus-square
  faPrint,
  faQuestion,
  faCircleQuestion, // FA4 question-circle
  faFloppyDisk, // FA4 save
  faMagnifyingGlass, // FA4 search
  faServer,
  faShare,
  faCartShopping, // FA4 shopping-cart
  faRightFromBracket, // FA4 sign-out
  faSortDown,
  faSortUp,
  faSpinner,
  faStop,
  faGaugeHigh, // FA4 tachometer
  faTag,
  faListCheck, // FA4 tasks
  faThumbsUp,
  faXmark, // FA4 times
  faTrash,
  faTrophy,
  faUser,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import {
  faSquareCheck as faSquareCheckRegular, // FA4 check-square-o (f046)
  faClock as faClockRegular, // FA4 clock-o
  faEnvelope as faEnvelopeRegular, // FA4 envelope-o
  faFile as faFileRegular, // FA4 file-o
  faFlag as faFlagRegular, // FA4 flag-o
  faFolder as faFolderRegular, // FA4 folder-o (f114)
  faFolderOpen as faFolderOpenRegular, // FA4 folder-open-o (f115)
  faSquare as faSquareRegular, // FA4 square-o
  faCircleXmark as faCircleXmarkRegular, // FA4 times-circle-o
  faTrashCan as faTrashCanRegular, // FA4 trash-o
} from "@fortawesome/free-regular-svg-icons";

export const FA4_NAME_TO_ICON: Record<string, IconDefinition> = {
  archive: faBoxArchive,
  "arrow-down": faArrowDown,
  "arrow-left": faArrowLeft,
  "arrow-right": faArrowRight,
  "arrow-up": faArrowUp,
  "arrows-alt": faUpDownLeftRight,
  "balance-scale": faScaleBalanced,
  bars: faBars,
  bell: faBell,
  "bell-slash": faBellSlash,
  briefcase: faBriefcase,
  calendar: faCalendarDays,
  check: faCheck,
  "check-circle": faCircleCheck,
  // REGULAR despite the no -o key names: checkboxTreeIcons.tsx matches v1
  // react-checkbox-tree's FA4 defaults, whose scss used the OUTLINE glyphs
  // check-square-o (f046), folder-o (f114), folder-open-o (f115).
  "check-square": faSquareCheckRegular,
  "chevron-down": faChevronDown,
  "chevron-right": faChevronRight,
  "clock-o": faClockRegular,
  cog: faGear,
  cogs: faGears,
  comment: faComment,
  "credit-card": faCreditCard,
  cutlery: faUtensils,
  download: faDownload,
  edit: faPenToSquare,
  "ellipsis-v": faEllipsisVertical,
  envelope: faEnvelope,
  "envelope-o": faEnvelopeRegular,
  exclamation: faExclamation,
  "exclamation-triangle": faTriangleExclamation,
  eye: faEye,
  file: faFile,
  "file-o": faFileRegular,
  flag: faFlag,
  "flag-o": faFlagRegular,
  folder: faFolderRegular, // outline -- see check-square note above
  "folder-open": faFolderOpenRegular, // outline -- see check-square note above
  gavel: faGavel,
  globe: faGlobe,
  home: faHouse,
  "info-circle": faCircleInfo,
  "line-chart": faChartLine,
  lock: faLock,
  map: faMap,
  "map-marker": faLocationDot,
  minus: faMinus,
  "minus-square": faSquareMinus,
  plus: faPlus,
  "plus-square": faSquarePlus,
  print: faPrint,
  question: faQuestion,
  "question-circle": faCircleQuestion,
  save: faFloppyDisk,
  search: faMagnifyingGlass,
  server: faServer,
  share: faShare,
  "shopping-cart": faCartShopping,
  "sign-out": faRightFromBracket,
  "sort-down": faSortDown,
  "sort-up": faSortUp,
  spinner: faSpinner,
  "square-o": faSquareRegular,
  stop: faStop,
  tachometer: faGaugeHigh,
  tag: faTag,
  tasks: faListCheck,
  "thumbs-up": faThumbsUp,
  times: faXmark,
  "times-circle-o": faCircleXmarkRegular,
  trash: faTrash,
  "trash-o": faTrashCanRegular,
  trophy: faTrophy,
  user: faUser,
  users: faUsers,
  warning: faTriangleExclamation,
};
